import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Starfield } from "../components/Starfield";
import { DiamondMark } from "../components/DiamondMark";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { state: { user: data } });
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="relative min-h-screen bg-cg-bg flex flex-col items-center justify-center gap-5">
      <Starfield count={50} />
      <div className="relative z-10 animate-floaty">
        <DiamondMark size={56} />
      </div>
      <p className="relative z-10 text-sm text-cg-texts font-mono uppercase tracking-widest">Aligning your session…</p>
    </div>
  );
}
